export default "__VITE_ASSET__ffoy8DUV__"